import { render, staticRenderFns } from "./channel-translations-tab.vue?vue&type=template&id=076b71fc"
import script from "./channel-translations-tab.vue?vue&type=script&lang=js"
export * from "./channel-translations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports